module.exports = ['DK', 'ES', 'PL', 'PE', 'UA', 'GB']
